import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';
import AuthModalContext from '../contexts/AuthModalContext';
import logoIcon from './assets/logo.svg';
import logoIconDark from './assets/logo-gold.svg';

class NavBar extends Component {
  static contextType = AuthModalContext;

  constructor(props) {
    super(props);
    this.state = {
      searchQuery: '',
      isDark: document.documentElement.classList.contains('tw-dark'),
    };
    this._darkObserver = null;
  }

  componentDidMount() {
    var nav = this;
    this._darkObserver = new MutationObserver(function() {
      var dark = document.documentElement.classList.contains('tw-dark');
      if (dark !== nav.state.isDark) nav.setState({ isDark: dark });
    });
    this._darkObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  }

  componentWillUnmount() {
    if (this._darkObserver) this._darkObserver.disconnect();
  }

  handleSearch = (e) => {
    e.preventDefault();
    if (this.state.searchQuery.trim() && this.props.history) {
      this.props.history.push(`/search/${this.state.searchQuery}`);
    }
  }

  handleSearchChange = (e) => {
    this.setState({ searchQuery: e.target.value });
  }

  render() {
    const { showSearch = true, currentPage } = this.props;
    
    return (
      <nav className="public-navbar">
        <div className="navbar-content">
          <div className="navbar-left">
            <Link to="/" className="logo">
              <img src={this.state.isDark ? logoIconDark : logoIcon} alt="Primal Marketplace" className="logo-icon" />
              <span className="logo-text">Primal Marketplace</span>
            </Link>
          </div>
          
          {showSearch && (
            <div className="navbar-center">
              <form onSubmit={this.handleSearch} className="search-form">
                <input
                  type="text"
                  placeholder="Search cards, collections..."
                  value={this.state.searchQuery}
                  onChange={this.handleSearchChange}
                  className="search-input"
                />
                <button type="submit" className="search-btn">
                  <i className="fa fa-search"></i>
                </button>
              </form>
            </div>
          )}
          
          <div className="navbar-right">
            {currentPage !== 'login' && (
              <button onClick={() => this.context.openAuthModal('login')} className="nav-link" style={{ background: 'none', border: 'none', cursor: 'pointer' }}>Login</button>
            )}
            {currentPage !== 'signup' && (
              <button onClick={() => this.context.openAuthModal('signup')} className="nav-link signup-btn" style={{ background: 'none', border: 'none', cursor: 'pointer' }}>Sign Up</button>
            )}
          </div>
        </div>
      </nav>
    );
  }
}

export default NavBar;
